<template>
  <div class="file-audio">
    <audio controls class="audio">
      <source :src="file.file_64" />
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
export default {
  name: "FileAudio",
  props: {
    file: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.audio {
  width: 100%;
}
</style>